import { render, staticRenderFns } from "./TalkizyJoinActions.vue?vue&type=template&id=1072ae48&scoped=true&"
import script from "./TalkizyJoinActions.vue?vue&type=script&lang=js&"
export * from "./TalkizyJoinActions.vue?vue&type=script&lang=js&"
import style0 from "./TalkizyJoinActions.vue?vue&type=style&index=0&id=1072ae48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1072ae48",
  null
  
)

export default component.exports